import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress, Paper } from "@mui/material";
import { useApiClient } from "../useApiClient";
import { API_CONFIG, getApiUrl } from "../config/api";

export default function LegacyCustomerRedirect() {
  const { systemName, localCustomerId } = useParams();
  const navigate = useNavigate();
  const { callApi } = useApiClient();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const resolveLegacy = async () => {
      setLoading(true);
      setError(null);
      try {
        console.log("Resolving legacy customer:", {
          systemName,
          localCustomerId,
        });
        const endpoint = `${API_CONFIG.ENDPOINTS.RESOLVE_LEGACY_CUSTOMER}/${systemName}/${localCustomerId}`;
        const url = getApiUrl(endpoint);
        const result = await callApi(url);
        const data = result.data || result;
        if (data && data.portalCustomerId) {
          navigate(
            `${API_CONFIG.ENDPOINTS.CUSTOMERS}/${data.portalCustomerId}`,
            { replace: true }
          );
        } else {
          setError("Customer mapping not found.");
        }
      } catch (err: any) {
        if (err?.response?.status === 404) {
          setError(
            `Customer was not found. ${
              err?.message || err?.response?.data?.error || ""
            }`
          );
        } else {
          setError(
            err?.message ||
              err?.response?.data?.error ||
              "An error occurred while resolving customer."
          );
        }
      } finally {
        setLoading(false);
      }
    };
    resolveLegacy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [systemName, localCustomerId]);

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 300,
      }}
    >
      <Paper sx={{ p: 4, minWidth: 320, textAlign: "center" }}>
        {loading ? (
          <>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography>Resolving legacy customer...</Typography>
          </>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : null}
      </Paper>
    </Box>
  );
}
